{
  "appName": "Profiling.app",
  "save": "Guardar",
  "cancel": "Cancelar",
  "or": "o",
  "loading": "Cargando…",
  "placeholder": "Aquí hay dragones…",
  "resendVerifyEmail": "Reenviar correo de confirmación",
  "changeLanguage": "Idioma",
  "form": {
    "saveFailed": "Algo salió mal. Inténtalo de nuevo."
  },
  "nav": {
    "dashboard": "Panel",
    "assignments": "Asignaciones",
    "briefs": "Briefs",
    "evaluations": "Evaluaciones",
    "billing": "Facturación",
    "myProfiles": "Mis perfiles",
    "admin": "Admin",
    "settings": "Configuración",
    "account": "Cuenta",
    "logout": "Cerrar sesión",
    "newWorkspace": "Nuevo espacio de trabajo"
  },
  "error": {
    "title": "Vaya, se nos cayó uno",
    "body": "Esto no debería haber pasado. Y sin embargo, aquí estamos.",
    "report": "Cuéntanos qué viste",
    "home": "Ir al inicio"
  },
  "locales": {
    "en": "English",
    "es_MX": "Español (México)"
  },
  "pagination": {
    "previous": "Página anterior",
    "next": "Página siguiente",
    "pageOf": "Página {{page}} de {{pages}}"
  }
}
